// extracted by mini-css-extract-plugin
export default {"error":"mjiEEGD1tgrMScGZqnkw"};